import React from 'react';
import { Skeleton } from '@mui/material';
import { ColumnFlexBox } from '../FlexBox';

/**
 * SkeletonList — placeholder card rows shown while a mobile list is loading its
 * first page. Replaces the global circular-progress backdrop (suppressed in
 * mobile mode) with content-shaped skeletons. See MOBILE_PLAN.md.
 */
const SkeletonList = function SkeletonList({
  count = 6,
  height = 64,
  gap = 1,
  padding = 1.5,
}) {
  return (
    <ColumnFlexBox sx={{ p: padding, gap }}>
      {Array.from({ length: count }).map((_, index) => (
        <Skeleton
          key={index}
          variant="rounded"
          height={height}
          sx={{ borderRadius: '16px' }}
        />
      ))}
    </ColumnFlexBox>
  );
};

export default SkeletonList;
